import MobileMenu from './modules/MobileMenu';
import DesktopMenu from './modules/DesktopMenu';
import SidebarHoist from './modules/SidebarHoist';
import SidebarExpand from './modules/SidebarExpand';
import AddNavSpanClasses from './modules/AddNavSpanClasses';
import StickyMargin from './modules/StickyMargin';
import AnsatteFilter from './modules/AnsatteFilter.js';
import SetSingleCourseInCalendar from './modules/setSingleCourseInCalendar';
import GetSingleCourse from './modules/getSingleCourse.js';
import CourseSteps from "./modules/CourseSteps.js";
import CourseCalendar from './modules/CourseCalendar';
import "./modules/ACFMaps";
import "./modules/IEFix";

/* Instantiate a new object */
const mobileMenu = new MobileMenu();
const sidebarHoist = new SidebarHoist();
const sidebarExpand = new SidebarExpand();
const addNavSpanClasses = new AddNavSpanClasses();
const stickyMargin = new StickyMargin();
const desktopMenu = new DesktopMenu();
const ansatteFilter = new AnsatteFilter();
const setSingleCourseInCalendar = new SetSingleCourseInCalendar();
const getSingleCourse = new GetSingleCourse();
const courseSteps = new CourseSteps();
const courseCalendar = new CourseCalendar();